<template>
    <div class="rp-helpdesk-conversation-initial-form">
        <div
            class="form"
            :disabled="isDisabled"
            :style="{
                borderTopColor: activeColor
            }"
        >
            <h4>{{ formHeaderLabel }}</h4>
            <div class="qualifying-properties">
                <div
                    v-for="property in fields"
                    :key="property.name"
                    class="qualifying-property"
                >   
                    <template v-if="property.value">
                        <div>
                            <Label :increaseBy="-2" bolder="500" color="#333333">{{ $t('inputPropDisplayNames.'+property.name)}} {{$t('inputFields.submitted')}}:</Label>
                            <VMargin :unit=".10" />
                            {{ property.value }}
                            <HMargin
                                :unit=".15"
                            />
                            <span
                                :style="{ color: '#85ce61' }"
                            >
                                <i class="el-icon-success"></i>
                            </span>
                        </div>
                    </template>
                    <template v-else>
                        <FormItem 
                            :property="property"
                            :showAllDataTypes="true"
                            @handleClick="handleClick"
                            :showSubmit="false"
                            @focus="handleFocus"
                            @handleEnter="handleEnter"
                            :popoverWidth="340"
                        />
                    </template>
                    <VMargin />
                </div>
                <div class="rp-messenger-submit-btn">
                    <StartConversationButton
                        :label="$t('initialForm.startChat')"
                        @click="handleSubmit"
                        buttonType="filled"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import MediaTypeText from './MediaTypeText';
import FormItem from './MediaSubForm/FormItem';
import StartConversationButton from '../StartConversationButton'
export default {
    components: {
        FormItem,
        StartConversationButton
    },
    props: {

        formConfiguration: {
            type: Object,
            required: true
        },
        formHeaderLabel: {
            type: String,
            required: true,
        },

    },

    data() {
        return {
            text: '',
            disabled: false,
            fields: {},
            isLoadingMap: {},
            EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            PHONE_REGEX: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
            isFormSubmitting: false,

        }
    },

    mounted() {
        this.updateFields();
    },

    watch: {
        ['formConfiguration.fields'](val) {
            this.updateFields();
        }
    },

    computed: {

        isDisabled() {
            return Object.values(this.fields)
                .some(({ isLoading }) => !!isLoading);
        },
        
        propertiesObject() {
			const o = {};
			this.properties.forEach(prop => o[prop.propertyName] = prop);
			return o;
        },
        conversationPropertiesObject() {
            const o = {};
			this.conversationProperties.forEach(prop => o[prop.propertyName] = prop);
			return o;
        },

        value() {
            return this.formConfiguration.mediaValue;
        },

        // isValid() {
        //     return this.value !== EMAIL_FORM_NULL_VALUE;
        // },

        ...mapGetters({
            properties: 'tenantProperties',
            conversationProperties: 'conversationProperties'
        }),
        activeColor() {
			try {
                return this.$root.configuration.style.activeColor || '#004e96'
            }
            catch(e) {
                return '#004e96'
            }
        }

    },

    methods: {

        updateFields() {
            const { userProperties } = this;

            this.formConfiguration.fields.forEach(({ name, groupName, value }) => {
                let  type, displayName, dropdownOption , dropdownListOption;
                if(groupName && groupName === 'Conversation Data') {
                    if(this.conversationPropertiesObject && !this.conversationPropertiesObject[name]) return;

                    type = this.conversationPropertiesObject[name].type;
                    displayName = this.conversationPropertiesObject[name].displayName;
                    dropdownOption = this.conversationPropertiesObject[name].dropdownOption;
                    dropdownListOption = this.conversationPropertiesObject[name].dropdownListOption;
                } else {
                    if(this.propertiesObject && !this.propertiesObject[name]) return;

                    type = this.propertiesObject[name].type;
                    displayName = this.propertiesObject[name].displayName;
                    dropdownOption = this.propertiesObject[name].dropdownOption;
                    dropdownListOption = this.propertiesObject[name].dropdownListOption;
                }

                const field = this.fields[name];
                let vModelValue = '';
                if(field && field['vModelValue']){
                    vModelValue = field['vModelValue'];
                }
                if(type === "boolean") {
                    vModelValue = vModelValue || false
                }
                if (field) {
                    this.$set(this.fields, name, { name, displayName, value, groupName, vModelValue, type, dropdownOption: dropdownListOption || dropdownOption || [], required: true });
                } else {
                    this.$set(this.fields, name, { name, displayName, value: '', groupName, vModelValue, type, dropdownOption: dropdownListOption || dropdownOption || [], required: true });
                }
            });
        },
        checkDataValidation(property) {
            if(property) {
                const { name, vModelValue } = property
                if(name === 'email') {
                    if(this.EMAIL_REGEX.test(vModelValue)){
                        return true
                    } else {
                        return false
                    }
                }
                else if(name === 'phone'){
                    if(this.PHONE_REGEX.test(vModelValue)){
                        return true
                    } else {
                        return false
                    }
                }
            } else {
            }
            return true
        },

        handleClick(property) {
            const { checkDataValidation } = this;
            if(checkDataValidation(property)) {
                const { vModelValue } = property;
                if (!(vModelValue && vModelValue.trim())) {
                    return;
                }
                this.$set(property, 'isLoading', true);
                this.$emit('submit', { type: 'form', message: this.message, data: { property } });
            } else {

            }
        
        },
        handleFocus(property) {
            //don't show error message on  focus
            this.$set(property, 'isError', false);
        },
        handleEnter(property) {
            this.handleSubmit()
        },

        handleSubmit() {
            const { checkDataValidation } = this;
            const { fields } = this;
            let formValid = true;

            for(let propertyName in fields) {
                const property = fields[propertyName]
                if(checkDataValidation(property)) {
                    const { vModelValue, required } = property;
                    if(Array.isArray(vModelValue) && vModelValue.length === 0){
                        formValid = false;
                        this.$set(property, 'isError', true);
                    }
                    else if (!(vModelValue) && required) {
                        formValid = false;
                        this.$set(property, 'isError', true);
                    }
                    else {
                        this.$set(property, 'isError', false);
                    }
                } else {
                    formValid = false;
                    //show validation error
                    this.$set(property, 'isError', true);
                }
            }
            //when form is completely valid
            //submit the data to parent component
            const setLoadingStatus = (status) => {
                this.isFormSubmitting = status;
                for(let propertyName in fields) {
                    const property = fields[propertyName];
                    this.$set(property, 'isLoading', status)
                }
            };
             // set form error
            // if(!formValid) {
            //     const firstErrorProp = fields[Object.keys(fields).find(fieldname => fields[fieldname].isError)]
            //     const errorMessage = `Please provide ${firstErrorProp.displayName.toLowerCase()}`
            //     this.showAlertOnFormCTA(errorMessage)
            // }
            
            if(formValid) {
                setLoadingStatus(true)
                this.$emit('submit', { type: 'form', data: { fields } });
                // setLoadingStatus(false)
            }
            

            
        }

    }

}

</script>

<style lang="scss" scoped>

.rp-helpdesk-conversation-initial-form {
    padding: 25px;
    max-height: calc(100% - 100px);
    overflow: auto;
    .form {
        padding: 1.5rem;
        @include for-size(tablet-landscape-up){
            padding: 2.5rem;
        }
        @include for-size(desktop-up){
            padding: 3.75rem;
        }
        background: white;
        border: 1px solid $greyColor;
        border-top: 2px solid $color;
        border-radius: 5px;
        box-shadow: 1px 3px 8px rgba(0, 0, 0, 0.1);
        h4{
            font-weight: 400;
            text-align: left;
            font-size: 1rem;
            @include for-size(desktop-up){
                font-size: 1.4rem;
            }
            margin-top: 0px;
            margin-bottom: 1.5rem;
            color: #333333;
        }
        .label {
            font-size: 14px;
            font-weight: 400;
            cursor: pointer;
        }

        .input {
            margin-top: .75rem;

            .el-input {
                font-size: 13px;
                font-weight: $fontWeight;
            }
        }

        &[disabled="disabled"] {
            opacity: 0.5;
            pointer-events: none;
        }
    }
    .qualifying-properties{
        font-size:13px;
        color: #4d4d4d;
        @include for-size(desktop-up){
            max-width: 500px;
            width: 100%;
        }
    }
}
.rp-messenger-submit-btn {
	display: flex;
    justify-content: flex-start;
	// .rp-start-conversation {
	// 	margin: 0 auto;
	// }
}

.rp-helpdesk-conversation-message-get-email.value-submitted {
    .label {
        font-size: 10px;
    }
}

.rp-qualifying-properties-error-msg{
    color: red;
    margin-top:5px;
}

</style>
